import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs, togglePanel } from "../../../actions/appActions";
import Button from "../../../components/form/Button";
import {
    getNotificationDuration,
    updateNotificationDuration,
} from "../CroActions";
import ServicesMonitoringGrid from "../components/grids/ServicesMonitoringGrid";

class Settings extends Component {
    state = {
        duration: "",
        loaded: false,
    };

    async componentDidMount() {
        this.props.breadcrumbs([{ label: "Nastavení" }]);
        const seconds = await this.props.dispatch(getNotificationDuration());
        this.setState({ duration: String(seconds), loaded: true });
    }

    onSave = async () => {
        const value = parseInt(this.state.duration, 10);
        if (isNaN(value) || value < 1) {
            this.props.togglePanel("Zadejte platné číslo větší než 0.");
            return;
        }
        await this.props.dispatch(updateNotificationDuration(value));
        this.props.togglePanel("Nastavení úspěšně uloženo.");
    };

    render() {
        if (!this.state.loaded) {
            return <div style={{ padding: 24, color: "#000" }}>Načítání...</div>;
        }

        return (
            <div>
              <div style={{ maxWidth: 600, color: "#000" }}>
                <h3>Nastavení oznámení</h3>
                  <div style={{ marginTop: 24 }}>
                      <label
                          style={{
                              display: "block",
                              marginBottom: 8,
                              fontWeight: 600,
                              color: "#000",
                          }}
                      >
                          Čas zobrazení oznámení o úspěšném odeslání/uložení (v sekundách):
                      </label>
                      <input
                          type="number"
                          min="1"
                          value={this.state.duration}
                          onChange={(e) => this.setState({ duration: e.target.value })}
                          style={{
                              padding: "8px 12px",
                              fontSize: 14,
                              border: "1px solid #ccc",
                              borderRadius: 4,
                              width: 200,
                              color: "#000",
                          }}
                      />
                  </div>
                  <div style={{ marginTop: 24 }}>
                      <Button label="Uložit" onClick={this.onSave} />
                  </div>
              </div>
              <div style={{ marginTop: '10vh' }}>
                <h3 style={{ marginBottom: 24 }}>Monitoring služeb</h3>
                <ServicesMonitoringGrid
                    gridName='serviceMonitoringGrid'
                    url={`/api/monitoring`}
                    adding={false}
                    filtering={false}
                    deleting={false}
                    showPaging={false}
                    pageSize={1000}
                    rowClass={(row) => {
                      if(row.status == 'ERROR' || row.certificateStatus == 'ERROR') {
                        return 'red';
                      } else if (row.status == 'OK' && row.certificateStatus == 'VALID') {
                        return 'green';
                      }
                    }}
                />
              </div>
            </div>
        );
    }
}

export default connect(null, { breadcrumbs, togglePanel })(Settings);